import React from 'react'
import ControlledModal from '../../../../components/modals/ControlledModal'
import ConfigsLoader from './_load/ConfigsLoader'
import ConfigsTable from './table/ConfigsTable'
import Header from './Header'
import { HorizontalLine } from '../../../../components/shapes/Line'
import { COLORS } from '@btime/constants'

const ListServiceOrderAutomaticDistributionConfigModal = props => {
  return (
    <ControlledModal width="80rem" {...props}>
      <ConfigsLoader>
        <Header />
        <HorizontalLine thin lineColor={COLORS.light3} />
        <ConfigsTable />
      </ConfigsLoader>
    </ControlledModal>
  )
}

export default ListServiceOrderAutomaticDistributionConfigModal
